import { useRef, useState } from "react";
import moment from "moment";
import Select from "react-select";
import MaterialTable, { MTableToolbar } from "material-table";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { ToastContainer } from "react-toastify";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import _ from "lodash";
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css'

import authHeader from "../../services/auth-header";
import Helper from "../../Helper";
import { getTrans as t } from "../../Localization/translations";
import { API } from "../../backend";
import { useNavigate } from "react-router-dom";

function TransactionContractview({
  id,
  contract_type,
  transactionNumber = "",
  setTransaction,
  setSelectedTab
}) {
  const tableRef = useRef();
  const ENABLED = {
    Y: "Yes",
    N: "No",
  };
  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [isLoading2, setIsLoading2] = useState(false);
  const [inputvalue, setValue] = useState("");
  const [currentPage2, setCurrentPage2] = useState(1);
  const [options2, setOptions2] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);

  var transactiontypes = "";

  const DR_CR = {
    D: "Debit",
    C: "Credit",
  };

  const range = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
    "Last Year": [
      moment().subtract(1, "year").startOf("year"),
      moment().subtract(1, "year").endOf("year"),
    ],
  };

  const handleEvent = (event, picker) => {
    setFromDate(picker.startDate);
    setToDate(picker.endDate);
  };

  const handleClear = () => {
    setFromDate("");
    setToDate("");
    setSelectedValue("");
    setTransaction("");
    tableRef.current.onQueryChange();
  };

  const handelSearch = () => {
    tableRef.current.onQueryChange();
  };

  const handelInputChange = (value) => {
    setValue(value);
    setCurrentPage2(1);
    setOptions2([]);
    loadOptions(value, 1);
  };

  const handleMenuScrollToBottomName = () => {
    loadOptions(inputvalue, currentPage2);
  };

  const handelChange = (value) => {
    setSelectedValue(value);
  };

  const loadOptions = async (value, page) => {
    try {
      if (value !== "") {
        setIsLoading2(true);
        const response = await fetch(
          `${API}accounting/transactiontypes/filter/?transaction_types=${value}&page=${page}`,
          { headers: authHeader() }
        );
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data;

          setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage2((prevPage) => prevPage + 1);
        } else {
          console.error("No data received or empty array from API.");
        }
        setIsLoading2(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading2(false);
    }
  };

  const hadelRefresh = () => {
    tableRef.current.onQueryChange();
    transactionNumber = ""
    setTransaction('')
  };

  const handleinvoiceView = (id) => {
    // navigate("/billing/viewinvoices", { state: id })
    setTransaction(id)
    setSelectedTab(6)
}
let navigate = useNavigate();

const handleNavigate = (id,object) => {
  if(id){

  
  if (object ==="CONTRACT"){

    navigate("/contract/view", { state: id });
  }
  else if (object==="INVOICE"){
    navigate("/billing/viewinvoices", { state: id });

  }
  else if (object==="RECEIPT"){
    navigate("/receipts/viewreceipts", { state: id });

  }
}
else{
  console.log("Id not found")
}
};

  return (
    // <div className="container-fluid">
    <div className="" style={{ position: "relative", minHeight: "80vh" }}>
      <div className="row py-2 mt-2" style={{ marginBottom: "50px" }}>
        <ToastContainer />
        <div
          className=""
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            overflow: "auto",
          }}
        >
          <div className=" mb-0">
            <div className="header pb-0">
              <div className="">
                <div>
                  {/* <h5 className="mb-0 tc">{t("Transactions")}</h5> */}
                </div>
              </div>
            </div>
            <div className="">
              <div className="p-0">
                {/* {contract_type === "Lease" ? ( */}
                <MaterialTable
                  tableRef={tableRef}
                  title={<h5 className="mb-0">{t("Transactions")}</h5>}
                  style={{
                    padding: "0.5rem 0.5rem",
                    backgroundColor: "var(--bs-table-bg)",
                    borderBottomWidth: "1px",
                    boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                  }}
                  columns={[
                    {
                      title: `${t("Transaction Type")}`,
                      field: "transaction_type",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none ">
                            {t("Transaction Type")}
                          </div>
                          <div className="tc text-bold">
                            {rowData.transaction_type}
                          </div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Transaction Number")}`,
                      field: "transaction_number",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Transaction Number")}
                          </div>
                          <div>{rowData.transaction_number}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Source Number")}`,
                      field: "source_number_value",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Source Number")}
                          </div>
                          <div className="tc text-bold" onClick={(e,data)=>handleNavigate(rowData.source_number,rowData.source_object)}>{rowData.source_number_value? rowData.source_number_value:""}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Source Object")}`,
                      field: "source_object",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Source Object")}
                          </div>
                          <div>{rowData.source_object? rowData.source_object:""}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Transaction Date")}`,
                      field: "transaction_date",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Transaction Date")}
                          </div>
                          <div>
                            {Helper.DateNormal(rowData.transaction_date)}
                          </div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },

                    {
                      title: `${t("Contract")}`,
                      // field: "contract_id.contract_number",
                      field: "contract_number",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("Contract")}
                          </div>
                          <div>
                            {" "}
                            {rowData.contract_number !== ""
                              ? rowData.contract_number
                              : "None"}
                          </div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },

                    // {
                    //   title: `${t("Total Invoice Amount")}`,
                    //   field: "total_invoice_amount",
                    //   render: (rowData) => <>
                    //     <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                    //     >{t("Total Invoice Amount")}</div>
                    //     <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}> {Helper.Amount(rowData.total_invoice_amount)}
                    //     </div></>,
                    //   headerStyle: {
                    //     verticalAlign: "inherit",
                    //     fontWeight: "bold",
                    //     textAlign: "right",
                    //   },
                    //   // cellStyle: {
                    //   //   textAlign: "right",
                    //   //   fontSize: 12,
                    //   // },
                    // },
                    {
                      title: `${t("Credit Amount")}`,
                      field: "cr_amount",
                      render: (rowData) => (
                        <>
                          <div
                            className={`d-xl-none tc d-md-none d-lg-none`}
                            style={{
                              textAlign: rowData.isSmallScreen
                                ? "left"
                                : "right",
                              fontSize: "12px",
                              fontWeight: rowData.isSmallScreen ? "bold" : "",
                            }}
                          >
                            {t("Credit Amount")}
                          </div>
                          <div
                            className={`d-none d-xl-block d-lg-block text-right`}
                            style={{ textAlign: "right", fontSize: "12px" }}
                          >
                            {rowData.cr_amount === 0
                              ? 0
                              : Helper.Amount(rowData.cr_amount)}
                          </div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "right",
                      },
                      // cellStyle: {
                      //   textAlign: "right",
                      //   fontSize: 12,
                      // },
                    },
                    {
                      title: `${t("Debit Amount ")}`,
                      field: "dr_amount",
                      render: (rowData) => (
                        <>
                          <div
                            className={`d-xl-none tc d-md-none d-lg-none`}
                            style={{
                              textAlign: rowData.isSmallScreen
                                ? "left"
                                : "right",
                              fontSize: "12px",
                              fontWeight: rowData.isSmallScreen ? "bold" : "",
                            }}
                          >
                            {t("Debit Amount ")}
                          </div>
                          <div
                            className={`d-none d-xl-block d-lg-block text-right`}
                            style={{ textAlign: "right", fontSize: "12px" }}
                          >
                            {rowData.dr_amount === 0
                              ? 0
                              : Helper.Amount(rowData.dr_amount)}
                          </div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "right",
                      },
                      // cellStyle: {
                      //   textAlign: "right",
                      //   fontSize: 12,
                      // },
                    },
                  ]}
                  data={(query) =>
                    new Promise((resolve, reject) => {
                      if (selectedValue) {
                        transactiontypes = selectedValue.transaction_type;
                      }
                      let url = API + "accounting/transactionheadercontract/?";
                      url += "per_page=" + query.pageSize;
                      url += "&page=" + (query.page + 1);
                      url += "&contract_id=" + id;
                      url += `&transaction_startdate=${fromDate !== "" ? Helper.DatePicker(fromDate) : ""
                        }`;
                      url += `&transaction_enddate=${toDate !== "" ? Helper.DatePicker(toDate) : ""
                        }`;
                      url += `&transaction_types=${transactiontypes !== "" ? transactiontypes : ""
                        }`;
                      url += `&transaction_id=${transactionNumber !== "" ? transactionNumber : ""
                        }`;
                      fetch(url, { headers: authHeader() })
                        .then((response) => response.json())
                        .then((result) => {
                          resolve({
                            data:
                              query.orderBy && query.orderDirection
                                ? _.orderBy(
                                  result.data,
                                  [query.orderBy.field],
                                  [query.orderDirection]
                                )
                                : result.data,
                            page: result.page - 1,
                            totalCount: result.total,
                          });
                        });
                    })
                  }
                  components={{
                    // Container: (props) => (
                    //   <div id="Payment">
                    //     <Paper {...props} />
                    //   </div>
                    // ),
                    Toolbar: (props) => (
                      <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                        <MTableToolbar {...props} />
                        <Tooltip title="Refresh" placement="center">
                          <span
                            onClick={hadelRefresh}
                            style={{
                              color: "#b4b7c5",
                              paddingRight: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/static/images/ic-refresh.svg"
                              }
                              alt="refresh Icon"
                              style={{ width: '25px' }}
                            />
                          </span>
                        </Tooltip>
                        &nbsp;&nbsp;

                        {/* <button
                          type="button"
                          className="refreshRequest btn-md border-0 btn btn-secondary  bg-gradient-secondary "
                          onClick={hadelRefresh}
                        >
                          {t("Refresh")}
                        </button> */}
                        <span
                          onClick={() => setState({ isPaneOpen: true })}
                          style={{
                            color: "#b4b7c5",
                            paddingRight: "10px",
                            cursor: "pointer",
                          }}
                        >
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/static/images/ic-filter.svg"
                            }
                            alt="Filter Icon"
                          />
                        </span>
                      </div>
                    ),
                  }}
                  onRowClick={(event, rowData, togglePanel) => {
                    // handleRowClick(rowData, togglePanel);
                    togglePanel();
                    // handleRowClick(rowData, togglePanel);
                  }}
                  detailPanel={(rowData) => {
                    return (
                      <div className="">
                        {/* <div className="table-responsive"> */}
                        <MaterialTable
                          title="Transaction Lines"
                          style={{
                            padding: "0.5rem 0.5rem",
                            // backgroundColor: "var(--bs-table-bg)",
                            borderBottomWidth: "1px",
                            boxShadow:
                              "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                            width: '100%',
                          }}
                          columns={[
                            {
                              title: "Line Number",
                              field: "",
                              render: (rowData, index) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Line Number")}
                                  </div>
                                  <div className="d-sm-block d-md-block d-lg-block d-xl-block" 
                                  // onClick={() => handleinvoiceView(rowData.id)}
                                  >
                                    {rowData.line_number}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: "Line Type",
                              field: "line_type",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} >
                                    {t("Line Type")}
                                  </div>
                                  <div className={`d-sm-block d-md-block d-lg-block d-xl-block `}  >
                                    {rowData.line_type}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: "Amount",
                              field: "amount",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} >
                                    {t("Amount")}
                                  </div>
                                  <div className={`d-sm-block d-md-block d-lg-block d-xl-block `} >
                                    {rowData.amount}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: "DR/CR Indicator",
                              field: "dr_cr_indicator",
                              render: (rowData) => (
                                <>
                                  <div className={`d-xl-none tc d-md-none d-lg-none`} >
                                    {t("DR/CR Indicator")}
                                  </div>
                                  <div className={`d-sm-block d-md-block d-lg-block d-xl-block `} >
                                    {DR_CR[rowData.dr_cr_indicator]}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                          ]}
                          data={(query) =>
                            new Promise((resolve, reject) => {
                              let transactionId = rowData.id;
                              let url =
                                API +
                                `accounting/transactionlines/${transactionId}?`;
                              url += "per_page=" + query.pageSize;
                              url += "&page=" + (query.page + 1);

                              fetch(url, { headers: authHeader() })
                                .then((response) => response.json())
                                .then((result) => {
                                  resolve({
                                    data:
                                      query.orderBy && query.orderDirection
                                        ? _.orderBy(
                                          result.data,
                                          [query.orderBy.field],
                                          [query.orderDirection]
                                        )
                                        : result.data,
                                    page: result.page - 1,
                                    totalCount: result.total,
                                  });
                                });
                            })
                          }
                          options={{
                            headerStyle: {
                              backgroundColor: "white",
                              color: "#245C7F",
                              fontSize: 12,
                            },
                            rowStyle: (rowData, index) => {
                              if (index % 2) {
                                return { backgroundColor: "#fff" };
                              }
                            },
                            sorting: true,
                            search: false,
                            paging: true,
                            emptyRowsWhenPaging: false, // To avoid of having empty rows
                            actionsColumnIndex: -1,
                          }}
                        />
                        {/* </div> */}
                      </div>
                    );
                  }}
                  options={{
                    headerStyle: {
                      backgroundColor: "white",
                      color: "#245C7F",
                      fontSize: 12,
                    },
                    rowStyle: (rowData, index) => {
                      if (index % 2) {
                        return { backgroundColor: "#fff" };
                      }
                    },
                    sorting: true,
                    search: false,
                    toolbar: true,
                    paging: true,
                    pageSize: 10, // make initial page size
                    emptyRowsWhenPaging: false, // To avoid of having empty rows
                    pageSizeOptions: [10, 15, 20, 50],
                    paginationType: "stepped",
                    showFirstLastPageButtons: false,
                    actionsColumnIndex: -1,
                  }}
                />
                {/* ) 
                : 
                (
                  <MaterialTable
                    tableRef={tableRef}
                    title={<h5 className="mb-0">{t("Transactions")}</h5>}
                    style={{
                      padding: "0.5rem 0.5rem",
                      backgroundColor: "var(--bs-table-bg)",
                      borderBottomWidth: "1px",
                      boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                    }}
                    columns={[
                      {
                        title: `${t("Transaction Type")}`,
                        field: "transactiontypes",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none ">
                              {t("Transaction Type")}
                            </div>
                            <div>{rowData.transactiontypes}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Transaction Number")}`,
                        field: "transaction_number",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Transaction Number")}
                            </div>
                            <div>{rowData.transaction_number}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Transaction Date")}`,
                        field: "transaction_date",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Transaction Date")}
                            </div>
                            <div>
                              {Helper.DateNormal(rowData.transaction_date)}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Total Income")}`,
                        field: "total_income",
                        render: (rowData) => (
                          <>
                            <div
                              className={`d-xl-none tc d-md-none d-lg-none`}
                              style={{
                                textAlign: rowData.isSmallScreen
                                  ? "left"
                                  : "right",
                                fontSize: "12px",
                                fontWeight: rowData.isSmallScreen ? "bold" : "",
                              }}
                            >
                              {t("Total Income")}
                            </div>
                            <div
                              className={`d-none d-xl-block d-lg-block text-right`}
                              style={{ textAlign: "right", fontSize: "12px" }}
                            >
                              {Helper.Amount(rowData.total_income)}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                      {
                        title: `${t("Gross Rent")}`,
                        field: "gross_rent",
                        render: (rowData) => (
                          <>
                            <div
                              className={`d-xl-none tc d-md-none d-lg-none`}
                              style={{
                                textAlign: rowData.isSmallScreen
                                  ? "left"
                                  : "right",
                                fontSize: "12px",
                                fontWeight: rowData.isSmallScreen ? "bold" : "",
                              }}
                            >
                              {t("Gross Rent")}
                            </div>
                            <div
                              className={`d-none d-xl-block d-lg-block text-right`}
                              style={{ textAlign: "right", fontSize: "12px" }}
                            >
                              {rowData.gross_rent === 0
                                ? 0
                                : Helper.Amount(rowData.gross_rent)}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                      {
                        title: `${t("Residual Value")}`,
                        field: "residual_value",
                        render: (rowData) => (
                          <>
                            <div
                              className={`d-xl-none tc d-md-none d-lg-none`}
                              style={{
                                textAlign: rowData.isSmallScreen
                                  ? "left"
                                  : "right",
                                fontSize: "12px",
                                fontWeight: rowData.isSmallScreen ? "bold" : "",
                              }}
                            >
                              {t("Residual Value")}
                            </div>
                            <div
                              className={`d-none d-xl-block d-lg-block text-right`}
                              style={{ textAlign: "right", fontSize: "12px" }}
                            >
                              {rowData.residual_value === 0
                                ? 0
                                : Helper.Amount(rowData.residual_value)}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                      {
                        title: `${t("Total Principal")}`,
                        field: "total_principal",
                        render: (rowData) => (
                          <>
                            <div
                              className={`d-xl-none tc d-md-none d-lg-none`}
                              style={{
                                textAlign: rowData.isSmallScreen
                                  ? "left"
                                  : "right",
                                fontSize: "12px",
                                fontWeight: rowData.isSmallScreen ? "bold" : "",
                              }}
                            >
                              {t("Total Principal")}
                            </div>
                            <div
                              className={`d-none d-xl-block d-lg-block text-right`}
                              style={{ textAlign: "right", fontSize: "12px" }}
                            >
                              {rowData.total_principal === 0
                                ? 0
                                : Helper.Amount(rowData.total_principal)}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                      {
                        title: `${t("Total Interest")}`,
                        field: "total_interest",
                        render: (rowData) => (
                          <>
                            <div
                              className={`d-xl-none tc d-md-none d-lg-none`}
                              style={{
                                textAlign: rowData.isSmallScreen
                                  ? "left"
                                  : "right",
                                fontSize: "12px",
                                fontWeight: rowData.isSmallScreen ? "bold" : "",
                              }}
                            >
                              {t("Total Interest")}
                            </div>
                            <div
                              className={`d-none d-xl-block d-lg-block text-right`}
                              style={{ textAlign: "right", fontSize: "12px" }}
                            >
                              {rowData.total_interest === 0
                                ? 0
                                : Helper.Amount(rowData.total_interest)}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                      {
                        title: `${t("Accrual Amount")}`,
                        field: "accrual_amount",
                        render: (rowData) => (
                          <>
                            <div
                              className={`d-xl-none tc d-md-none d-lg-none`}
                              style={{
                                textAlign: rowData.isSmallScreen
                                  ? "left"
                                  : "right",
                                fontSize: "12px",
                                fontWeight: rowData.isSmallScreen ? "bold" : "",
                              }}
                            >
                              {t("Accrual Amount")}
                            </div>
                            <div
                              className={`d-none d-xl-block d-lg-block text-right`}
                              style={{ textAlign: "right", fontSize: "12px" }}
                            >
                              {rowData.accrual_amount === 0
                                ? 0
                                : Helper.Amount(rowData.accrual_amount)}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                      {
                        title: `${t("Contract")}`,
                        field: "contract_id.contract_number",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Contract")}
                            </div>
                            <div>
                              {" "}
                              {rowData.contract_id.contract_number !== ""
                                ? rowData.contract_id.contract_number
                                : "None"}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("Asset Cost")}`,
                        field: "asset_cost",
                        render: (rowData) => (
                          <>
                            <div
                              className={`d-xl-none tc d-md-none d-lg-none`}
                              style={{
                                textAlign: rowData.isSmallScreen
                                  ? "left"
                                  : "right",
                                fontSize: "12px",
                                fontWeight: rowData.isSmallScreen ? "bold" : "",
                              }}
                            >
                              {t("Asset Cost")}
                            </div>
                            <div
                              className={`d-none d-xl-block d-lg-block text-right`}
                              style={{ textAlign: "right", fontSize: "12px" }}
                            >
                              {rowData.asset_cost === 0
                                ? 0
                                : Helper.Amount(rowData.asset_cost)}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                      // {
                      //   title: `${t("Invoice Amount")}`,
                      //   field: "invoice_amount",
                      //   render: (rowData) => <>
                      //     <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                      //     >{t("Invoice Amount")}</div>
                      //     <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}> {Helper.Amount(rowData.invoice_amount)}
                      //     </div></>,
                      //   headerStyle: {
                      //     verticalAlign: "inherit",
                      //     fontWeight: "bold",
                      //     textAlign: "right",
                      //   },
                      //   // cellStyle: {
                      //   //   textAlign: "right",
                      //   //   fontSize: 12,
                      //   // },
                      // },
                      {
                        title: `${t("Tax Amount")}`,
                        field: "tax_amount",
                        render: (rowData) => (
                          <>
                            <div
                              className={`d-xl-none tc d-md-none d-lg-none`}
                              style={{
                                textAlign: rowData.isSmallScreen
                                  ? "left"
                                  : "right",
                                fontSize: "12px",
                                fontWeight: rowData.isSmallScreen ? "bold" : "",
                              }}
                            >
                              {t("Invoice Amount")}
                            </div>
                            <div
                              className={`d-none d-xl-block d-lg-block text-right`}
                              style={{ textAlign: "right", fontSize: "12px" }}
                            >
                              {rowData.tax_amount === 0
                                ? 0
                                : Helper.Amount(rowData.tax_amount)}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                      // {
                      //   title: `${t("Total Invoice Amount")}`,
                      //   field: "total_invoice_amount",
                      //   render: (rowData) => <>
                      //     <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                      //     >{t("Total Invoice Amount")}</div>
                      //     <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}> {Helper.Amount(rowData.total_invoice_amount)}
                      //     </div></>,
                      //   headerStyle: {
                      //     verticalAlign: "inherit",
                      //     fontWeight: "bold",
                      //     textAlign: "right",
                      //   },
                      //   // cellStyle: {
                      //   //   textAlign: "right",
                      //   //   fontSize: 12,
                      //   // },
                      // },
                      {
                        title: `${t("Receipt Amount")}`,
                        field: "receipt_amount",
                        render: (rowData) => (
                          <>
                            <div
                              className={`d-xl-none tc d-md-none d-lg-none`}
                              style={{
                                textAlign: rowData.isSmallScreen
                                  ? "left"
                                  : "right",
                                fontSize: "12px",
                                fontWeight: rowData.isSmallScreen ? "bold" : "",
                              }}
                            >
                              {t("Receipt Amount")}
                            </div>
                            <div
                              className={`d-none d-xl-block d-lg-block text-right`}
                              style={{ textAlign: "right", fontSize: "12px" }}
                            >
                              {rowData.receipt_amount === 0
                                ? 0
                                : Helper.Amount(rowData.receipt_amount)}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                      {
                        title: `${t("Applied Amount ")}`,
                        field: "applied_amount",
                        render: (rowData) => (
                          <>
                            <div
                              className={`d-xl-none tc d-md-none d-lg-none`}
                              style={{
                                textAlign: rowData.isSmallScreen
                                  ? "left"
                                  : "right",
                                fontSize: "12px",
                                fontWeight: rowData.isSmallScreen ? "bold" : "",
                              }}
                            >
                              {t("Applied Amount ")}
                            </div>
                            <div
                              className={`d-none d-xl-block d-lg-block text-right`}
                              style={{ textAlign: "right", fontSize: "12px" }}
                            >
                              {rowData.applied_amount === 0
                                ? 0
                                : Helper.Amount(rowData.applied_amount)}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                      {
                        title: `${t("Accounted")}`,
                        field: "accounted_yn",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Accounted")}
                            </div>
                            <div> {ENABLED[rowData.accounted_yn]}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                    ]}
                    data={(query) =>
                      new Promise((resolve, reject) => {
                        if (selectedValue) {
                          transactiontypes = selectedValue.transaction_type;
                        }
                        let url = API + "accounting/transactioncontract/?";
                        url += "per_page=" + query.pageSize;
                        url += "&page=" + (query.page + 1);
                        url += "&contract_id=" + id;
                        url += `&transaction_startdate=${
                          fromDate !== "" ? Helper.DatePicker(fromDate) : ""
                        }`;
                        url += `&transaction_enddate=${
                          toDate !== "" ? Helper.DatePicker(toDate) : ""
                        }`;
                        url += `&transaction_types=${
                          transactiontypes !== "" ? transactiontypes : ""
                        }`;
                        fetch(url, { headers: authHeader() })
                          .then((response) => response.json())
                          .then((result) => {
                            resolve({
                              data:
                                query.orderBy && query.orderDirection
                                  ? _.orderBy(
                                      result.data,
                                      [query.orderBy.field],
                                      [query.orderDirection]
                                    )
                                  : result.data,
                              page: result.page - 1,
                              totalCount: result.total,
                            });
                          });
                      })
                    }
                    components={{
                      // Container: (props) => (
                      //   <div id="Payment">
                      //     <Paper {...props} />
                      //   </div>
                      // ),
                      Toolbar: (props) => (
                        <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                          <MTableToolbar {...props} />
                          <span
                            onClick={() => setState({ isPaneOpen: true })}
                            style={{
                              color: "#b4b7c5",
                              paddingRight: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/static/images/ic-filter.svg"
                              }
                              alt="Filter Icon"
                            />
                          </span>
                        </div>
                      ),
                    }}
                    options={{
                      headerStyle: {
                        backgroundColor: "white",
                        color: "#245C7F",
                        fontSize: 12,
                      },
                      rowStyle: (rowData, index) => {
                        if (index % 2) {
                          return { backgroundColor: "#fff" };
                        }
                      },
                      sorting: true,
                      search: false,
                      toolbar: true,
                      paging: true,
                      pageSize: 10, // make initial page size
                      emptyRowsWhenPaging: false, // To avoid of having empty rows
                      pageSizeOptions: [10, 15, 20, 50],
                      paginationType: "stepped",
                      showFirstLastPageButtons: false,
                      actionsColumnIndex: -1,
                    }}
                  />
                )} */}
              </div>
            </div>
          </div>
          <SlidingPane
            className="some-custom-class"
            overlayClassName="some-custom-overlay-class"
            isOpen={state1.isPaneOpen}
            title="Filter By"
            subtitle=""
            onRequestClose={() => {
              setState({ isPaneOpen: false });
            }}
          >
            <div className="col-xl-12">
              <div className="form-group row">
                <label className="col-lg-12 col-form-label">
                  {t("Transaction Type")}
                </label>
                <div className="col-lg-12">
                  <Select
                    value={selectedValue}
                    filterOption={false}
                    options={options2}
                    isClearable
                    onInputChange={handelInputChange}
                    getOptionLabel={(options) => options.transaction_type}
                    getOptionValue={(options) => options.transaction_type}
                    isLoading={isLoading2}
                    placeholder={t("Search for Transactiontype(%for All)")}
                    onMenuScrollToBottom={handleMenuScrollToBottomName}
                    onChange={handelChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-xl-12">
              <div className="form-group row">
                <label className="col-lg-12 col-form-label">
                  {t("Transaction Date Range")}
                </label>
                <div className="col-lg-12">
                  <DateRangePicker
                    initialSettings={{ ranges: range }}
                    startDate={fromDate !== "" ? fromDate : ""}
                    endDate={toDate !== "" ? toDate : ""}
                    alwaysShowCalendars={true}
                    onEvent={handleEvent}
                  >
                    <span className="form-control">
                      {fromDate !== ""
                        ? Helper.DateNormal(fromDate)
                        : "Select Start Date"}{" "}
                      to{" "}
                      {toDate !== ""
                        ? Helper.DateNormal(toDate)
                        : "Select End Date"}
                    </span>
                  </DateRangePicker>
                </div>
              </div>
            </div>
            <div className="col-xl-12">
              <div className="form-group row">
                <div
                  className="col-lg-12 text-left"
                  style={{ marginTop: "30px" }}
                >
                  <button
                    type="button"
                    className="clearReceipt btn bg-gradient-secondary btn-m ms-auto mb-0"
                    onClick={handleClear}
                  >
                    {t("Reset")}
                  </button>
                  &nbsp;&nbsp;
                  <button
                    type="button"
                    className="filter add btn btn-primary btn-m ms-auto mb-0"
                    onClick={handelSearch}
                  >
                    {t("Apply")}
                  </button>
                  &nbsp;&nbsp;
                </div>
              </div>
            </div>
          </SlidingPane>
        </div>
      </div>
    </div>
  );
}

export default TransactionContractview;
